import React, { useState } from 'react';
import { useUsers } from '../context/UsersContext';
import { C } from '../utils/styles';
import Icon from './Icon';
import { formatPhone } from '../utils/formatters';

export default function ProfileModal({ onClose }) {
  const { currentUser, updateUser } = useUsers();
  const [firstName, setFirstName] = useState(currentUser.firstName);
  const [lastName, setLastName] = useState(currentUser.lastName);
  const [phone, setPhone] = useState(formatPhone(currentUser.phone || ''));
  const [title, setTitle] = useState(currentUser.title || '');
  const [error, setError] = useState('');

  const handlePhoneChange = (e) => {
    const formatted = formatPhone(e.target.value);
    setPhone(formatted);
  };

  const handleSave = async () => {
    setError('');

    if (!firstName.trim() || !lastName.trim()) {
      setError('First name and last name are required');
      return;
    }

    const success = await updateUser(currentUser.id, {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      phone: phone.trim(),
      title: title.trim(),
    });

    if (success) {
      onClose();
    } else {
      setError('Failed to update profile. Please try again.');
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1001,
        padding: 20,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          borderRadius: 12,
          padding: 28,
          maxWidth: 500,
          width: '100%',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ fontSize: 18, fontWeight: 800, margin: 0, marginBottom: 20 }}>
          Edit Profile
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 24 }}>
          <div>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: C.textMid, marginBottom: 6 }}>
              Email
            </label>
            <div style={{
              padding: '10px 14px',
              fontSize: 13,
              background: C.bg,
              color: C.textMid,
              borderRadius: 6,
              border: `1px solid ${C.border}`,
            }}>
              {currentUser.email} (cannot be changed)
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: C.text, marginBottom: 6 }}>
                First Name *
              </label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  fontSize: 13,
                  border: `1px solid ${C.border}`,
                  borderRadius: 6,
                  background: C.bg,
                  color: C.text,
                }}
                required
              />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: C.text, marginBottom: 6 }}>
                Last Name *
              </label>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  fontSize: 13,
                  border: `1px solid ${C.border}`,
                  borderRadius: 6,
                  background: C.bg,
                  color: C.text,
                }}
                required
              />
            </div>
          </div>

          <div>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: C.text, marginBottom: 6 }}>
              Title
            </label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g., Account Manager, CEO"
              style={{
                width: '100%',
                padding: '10px 14px',
                fontSize: 13,
                border: `1px solid ${C.border}`,
                borderRadius: 6,
                background: C.bg,
                color: C.text,
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: C.text, marginBottom: 6 }}>
              Phone
            </label>
            <input
              type="tel"
              value={phone}
              onChange={handlePhoneChange}
              placeholder="(555) 123-4567"
              maxLength={14}
              style={{
                width: '100%',
                padding: '10px 14px',
                fontSize: 13,
                border: `1px solid ${C.border}`,
                borderRadius: 6,
                background: C.bg,
                color: C.text,
              }}
            />
          </div>

          <div style={{
            background: C.blueLight,
            border: `1px solid ${C.blue}`,
            borderRadius: 6,
            padding: 12,
            fontSize: 11,
            color: C.textMid,
          }}>
            <Icon name="information-circle-outline" style={{ fontSize: 14, marginRight: 6 }} />
            Your role can only be changed by a Super User in Admin settings.
          </div>
        </div>

        {error && (
          <div style={{
            background: C.redLight,
            border: `1px solid ${C.red}`,
            borderRadius: 6,
            padding: 10,
            fontSize: 12,
            color: C.red,
            fontWeight: 600,
            marginBottom: 16,
          }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: '10px',
              background: 'transparent',
              color: C.textMid,
              border: `1px solid ${C.border}`,
              borderRadius: 6,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            style={{
              flex: 1,
              padding: '10px',
              background: C.accent,
              color: 'white',
              border: 'none',
              borderRadius: 6,
              fontSize: 13,
              fontWeight: 700,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
            }}
          >
            <Icon name="save-outline" style={{ fontSize: 14 }} />
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}
